export const productsFiltersTypes = {
    sort: 1,
    range: 2,
    checkbox: 3,
    switch: 4
}

export const rangeLabels = ["from", "to"]

export const rangeLabelTypes = {
    from: 0,
    to: 1
}